import React from "react";
import { useParams } from "react-router-dom";
import "./delegate.css";

import Template from "./Template/Template";
import TemplateDetail from "./Template/TemplateDetail";

export default function Delegate() {
  const { id } = useParams();

  return (
    <>
      <div className="delegate-header">
        <h2 className="delegate-title">대의원 활동 인증서</h2>
      </div>

      {id ? <TemplateDetail /> : <Template />}
    </>
  );
}